module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer012"
    }
  }, [_c('p', {
    staticClass: "Prelims-head"
  }, [_vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticClass: "Prelim-main"
  }, [_vm._v("Desnà is a civil servant mum of three who lives in a small town in Northern Ireland. Her previously published work includes the much-loved children’s tale "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Little Mouse’s Big Ambition")]), _vm._v(".  ")]), _vm._v(" "), _c('p', {
    staticClass: "Prelim-main"
  }, [_vm._v("Along with her young family, Desnà has a great love for all things outdoors, and outside of writing can often be found exploring her way around the island on which she lives.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a35b453a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781398481954_EPUB.vue
// module id = 57
// module chunks = 0